import { render, staticRenderFns } from "./DashboardNewsItem.vue?vue&type=template&id=1187c31f"
import script from "./DashboardNewsItem.vue?vue&type=script&lang=js"
export * from "./DashboardNewsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports